export default __webpack_public_path__ + "static/media/green-sun-crop.e6d6fd08.jpg";